import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import moment from "moment";

const AnaliticCard = ({ cardData, setCurrentIterationUUID }) => {
  const params = useParams();
  const moduleUUID = params?.uuid;

  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);

  const [noOfIteration, setNoOfIteration] = useState({});
  const [timeTakenError, setTimeTakenError] = useState({});
  const [errors, setErrors] = useState({});
  const [lastIteration, setLastIteration] = useState({});
  const [options, setOptions] = useState([]);
  const [defaultValue, setDefaultValue] = useState({});

  useEffect(() => {
    setNoOfIteration({ ...cardData?.sessionCounts });
    setTimeTakenError({ ...cardData?.durations });
    setErrors({ ...cardData.errors });
    
    let iterations = cardData?.sessions?.length > 0
        ? [...cardData.sessions].reverse().map((e, i) => ({
            id: e.id,
            value: e.uuid,
            label: `Iteration ${i + 1} ${e.mode === "GUIDED" ? " (T)" : " (A)"} `,
            mode: e.mode,
          }))
        : [];
    if (iterations?.length) {
      setOptions([...iterations]);
      let iterationLast = iterations.slice(-1)[0];
      setCurrentIterationUUID({ ...iterationLast });
      setDefaultValue({ ...iterationLast });
      setLastIteration({ ...cardData.lastIteration, title: iterationLast.label.split("(")?.[0]?.trim() || null });
    }else{
      setLastIteration({ ...cardData.lastIteration, title: null });
    }

  }, [cardData]);

  const handleChange = (selected) => {
    setDefaultValue(selected);
    let getCurrentIteration = cardData?.sessions.filter((e) => e.id == selected.id)[0];
    setLastIteration({ ...getCurrentIteration, title: selected?.label?.split("(")?.[0]?.trim() || null });
    setCurrentIterationUUID({
      id: getCurrentIteration.id,
      value: getCurrentIteration.uuid,
      label: "",
      mode: getCurrentIteration.mode,
    });
  };

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="analyticcbox  p-3">
            <h6 className="d-flex justify-content-between mb-0">No. of Iteration</h6>
            <div>
              <div className="py-1">
                <h5 className="mb-0"> {noOfIteration.all || 0}</h5>
              </div>
              <div className="d-flex justify-content-between">
                <p className="mb-0">Training : {noOfIteration.guided || 0} </p>
                <p className="mb-0">Assessment : {noOfIteration.unguided || 0} </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col px-2">
          <div className="analyticcbox  p-3">
            <h6 className="d-flex justify-content-between mb-0">
              <span>Average Time</span>
            </h6>
            <div>
              <div className="py-1">
                <h5 className="mb-0"> {timeTakenError?.all?.average?.humanReadable || "NA"} </h5>
              </div>
              <div>
                <p className="mb-0">Training: {timeTakenError?.guided?.average?.humanReadable || "NA"} </p>
                <p className="mb-0">Assessment: {timeTakenError?.unguided?.average?.humanReadable || "NA"} </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col px-2">
          <div className="analyticcbox p-3">
            <h6 className="d-flex justify-content-between mb-0">Average Errors</h6>
            <div>
              <div className="py-1">
                <h5 className="mb-0">{errors.all} </h5>
              </div>
              <div className="d-flex justify-content-between">
                {/* <p className="mb-0">Training: {errors.guided} </p> */}
                <p className="mb-0">Assessment: {errors.unguided} </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col px-2">

                </div> */}

        <div className="col px-2">
          <div className="analyticcbox">
            <p className="lastiteration">  {lastIteration?.title || "Iteration"}  </p>
            <div className="d-flex p-3 pt-2">
              <div>
                <h6 className="d-flex justify-content-between">Errors</h6>
                <div>
                  <div className="d-flex justify-content-between">
                    <h5 className="mb-0">{lastIteration?.errors}</h5>
                  </div>
                </div>
              </div>
              <div className="ps-4">
                <h6 className="d-flex justify-content-between"> Time Taken</h6>
                <div>
                  <div className="d-flex justify-content-between">
                    <h5 className="mb-0">{lastIteration?.time?.humanReadable || "NA"}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col px-2">
                    <div className="analyticcbox p-3">
                        <h6 className="d-flex justify-content-between mb-0">
                            Time Taken
                        </h6>
                        <div>
                            <div className="d-flex justify-content-between">
                            <h5 className="mb-0">{lastIteration?.time?.humanReadable || "NA"}</h5>
                            </div>
                        </div>
                    </div>
                </div> */}

        <div className="col px-2">
          <div className="analyticcbox iterationselection">
            <Select options={options} value={defaultValue} onChange={handleChange} placeholder="Iterations" />
            <div className="px-2">
              <p
                className="d-flex justify-content-between mt-2 mb-1 pb-1"
                style={{ borderBottom: "1px solid rgb(204, 204, 204)" }}
              >
                <span>Dated</span> <span> {moment(lastIteration.startTime).format("DD-MM-YYYY")} </span>
              </p>
              <p className="d-flex justify-content-between mt-2 mb-1 pb-1">
                <span>
                  Mode:{" "}
                  {lastIteration.mode == "UNGUIDED" ? "Assessment" : lastIteration.mode == "GUIDED" ? "Training" : null}
                </span>{" "}
                <span> {moment(lastIteration.startTime).format("hh:mm a")} </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnaliticCard;
